
import { lazy, Suspense,useEffect,useState } from "react";
// import "@fontsource/poppins";
// import "@fontsource/great-vibes";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { useHyperlink } from "./contexts/HyperlinkProvider.js";
import usePavanData from "./hooks/usePavanData";



const Home = lazy(() => import("./Home"));
const Samantha = lazy(() => import("./Home-Samantha"));
// const KellyHome = lazy(() => import("./KellyHome"));
// const GiftyHome = lazy(() => import("./GiftyHome"));
// const Error = lazy(() => import("./components/error/ErrorPage"));






export default function App() {


 
  const baseName = process.env.REACT_APP_BASENAME;
  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [swmcLink, setSwmcLink] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();
  const pavanData = usePavanData();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 0);
      const swmcLink = await getHyperLink("websites", "swmc", 1);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West");
      setSwmcLink(swmcLink || "Sun West Mortgage Company, Inc.");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);



  return (
      <BrowserRouter basename={baseName}>
        <Suspense fallback={<div className="text-center"><Spinner /></div>}>
          <Routes>
            <Route path="/samantha" element={<Samantha angelAiLink={angelAiLink} />} />
            {/* <Route path="/kellyharmon" element={<KellyHome />} /> */}
            <Route path="/" element={<Home angelAiLink={angelAiLink} swmcLink={swmcLink} sunwestLink={sunwestLink} pavanLink={pavanLink} pavanData={pavanData}/>} />
            {/* <Route path="*" element={<Error />} /> */}
          </Routes>
        </Suspense>
      </BrowserRouter>
  );
}

